import Vue from 'vue'
import Vuex from 'vuex'
import { getToken, setToken, removeToken } from '@/utils/auth'
Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        token: '',
        //用户是否登录
        user: getToken() || null,
    },
    getters: {}, // 计算属性
    mutations: {// 修改state中数据的一些方法
        setLoginStatus(state, user) {
            state.user = user;
            setToken(user);
        }
    },
    actions: {}, // 异步方法
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js